const FETCH_POSTING_LEADS = 'estadisticas/rendimiento/FETCH_POSTING_LEADS';
const FETCH_POSTING_LEADS_COMPLETED = 'estadisticas/rendimiento/FETCH_POSTING_LEADS_COMPLETED';
const FETCH_POSTING_LEADS_FAILED = 'estadisticas/rendimiento/FETCH_POSTING_LEADS_FAILED';
const FETCH_POSTING_LEADS_CHARTS = 'estadisticas/rendimiento/FETCH_POSTING_LEADS_CHARTS';
const FETCH_POSTING_LEADS_CHARTS_COMPLETED = 'estadisticas/rendimiento/FETCH_POSTING_LEADS_CHARTS_COMPLETED';
const FETCH_POSTING_LEADS_CHARTS_FAILED = 'estadisticas/rendimiento/FETCH_POSTING_LEADS_CHARTS_FAILED';

export {
  FETCH_POSTING_LEADS,
  FETCH_POSTING_LEADS_COMPLETED,
  FETCH_POSTING_LEADS_FAILED,
  FETCH_POSTING_LEADS_CHARTS,
  FETCH_POSTING_LEADS_CHARTS_COMPLETED,
  FETCH_POSTING_LEADS_CHARTS_FAILED
};
